import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "@/components/Sidebar";
import { Sheet, SheetContent } from "@/components/ui/sheet";

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex min-h-screen bg-background">
      <div className="hidden md:block">
        <Sidebar />
      </div>

      <div className="md:hidden fixed top-0 inset-x-0 z-40 h-14 bg-[#3d5a75] flex items-center gap-3 px-4 shadow">
        <button onClick={() => setOpen(true)} aria-label="Menü öffnen" data-testid="mobile-menu-button" className="text-white p-1">
          <Menu size={24} />
        </button>
        <img src="/logo-katechese-white.png" alt="katechese.online" className="h-8 w-auto object-contain" />
      </div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="p-0 w-[260px] border-0" data-testid="mobile-sidebar">
          <Sidebar onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>

      <main className="flex-1 min-w-0 pt-14 md:pt-0">
        <Outlet />
      </main>
    </div>
  );
}
